<template></template>

<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import Config from "../../../config-app/config";

export default {
  name: "swal-import-rose",
  mixins: [mixins],
  components: {},
  mounted() {
    db.on("showImportRose", this.importRose);
  },
  destroyed() {
    db.off("showImportRose", this.importRose);
  },
  computed: {},
  methods: {
    importRose() {
      Swal.fire({
        icon: "warning",
        title: "Attenzione",
        html:
          '<div style="text-align: left; font-size: smaller;">' +
          'Stai per <b>sovrascrivere</b> le squadre/rose/crediti di Asta Live con <a style="color: #009688;" target="_blank" href="' +
          Config.HOST +
          "/fantacalcio/rose-lega/" +
          this.asta_info.lega.ID_Lega + "/" +
           this.asta_info.lega.ID_Divisione +
          '">le rose del sito/app</a>.<br>' +
          'Questa è un\'<b>operazione irreversibile</b>' +
          '<div style="margin-top: 10px; border-radius: 3px; color: tomato; background: #FFEBEE; padding: 10px">' +
          '<i class="fa fa-warning"></i>. Se l\'asta era già iniziata assicurati di segnarti le assegnazioni non ancora salvate perchè saranno annullate.' +
          "</div>" +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Ho capito. Riallinea.",
        cancelButtonText: "Annulla",
        preConfirm: () => {
          return this.preConfirmApiCall();
        },
      }).then((result) => {
        if (result.isConfirmed == true) {
          this.handleApiCall("/firebase_import_rose.php", 'importRose');
        }
      });
    },
  },
};
</script>
<style></style>
